import { useRef, useState } from "react"
import { BiCheck } from "react-icons/bi"
import { FiCopy } from "react-icons/fi"
import { useAppSelector } from "../../store/hooks"
import Singnaturea from "../signatures/signatureA"
import Signatureb from "../signatures/signatureB"
interface InputCopyProps {
  text: string,
  value: string,
}
const SignatureCopy = ({ text, value }: InputCopyProps) => {
  /* const { id_employee, name, email, phone, address, title, employ_phone, employ_address, employ_title, company, customer_phone } = useAppSelector(state => state.user) */
  const {link} = useAppSelector(state => state.campaign.detail)
  const [copied, setCopied] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)
  let set_link_a = value.replaceAll('{link}', link);
  let style_set = set_link_a.replaceAll('✝','<sup>✝</sup>')
/*   let value1 = value.replace('{name}', name ? name : '')
  let value2 = value1.replace('{job}', title ? title : employ_title ? employ_title:'')
  let value3 = value2.replace('{brand}', company? company : '')
  let value4 = value3.replace('{phone}', phone? phone : employ_phone ? employ_phone :'')
  let value5 = value4.replace('{email}', email? email : '')
  let value6 = value5.replace('{address}', address? address: employ_address?employ_address:'')
  let value7 = value6.replace('{customer}', customer_phone ? customer_phone: '') */

  /* const Copyurl = () => {
    let content = ref.current?.innerHTML || ''
    navigator.clipboard.writeText(content)
      .then(() => {
        setCopied(true)
        setTimeout(function () { setCopied(false) }, 1000);
      })
      .catch((err) => {
        console.log('Something went wrong', err);
      })
  } */

  const CopySelect =()=> {
    var container = document.createElement('div')
    container.innerHTML = ref.current?.innerHTML || ''
    document.body.appendChild(container)
    window.getSelection()?.removeAllRanges();
    let range = document.createRange();
    range.selectNode(container);
    window.getSelection()?.addRange(range);
    document.execCommand('copy');
    window.getSelection()?.removeAllRanges();
    document.body.removeChild(container)
    setCopied(true)
    setTimeout(function () { setCopied(false) }, 1000);
  }

  return (
    <div className="email-signature__container">
      <div className="email-signature__header">
        <div className="email-signature__title">
          {text}
        </div>
        {
          copied ?
            <div className="email-signature__box-copied">
              Copied <BiCheck />
            </div>
            :
            <div className="email-signature__box-copy" onClick={CopySelect}>
              <FiCopy />Copy
            </div>
        }
      </div>
      <div className="email-signature__content" ref={ref}>
        <div dangerouslySetInnerHTML={{ __html: style_set }} />
        {/* <Singnaturea/>
        <Signatureb/> */}
      </div>
    </div>
  )
}

export default SignatureCopy